<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1240 558" style="enable-background:new 0 0 1240 558;" xml:space="preserve">
<g id="FILL">
	<router-link :to="{ name: 'apartment', params: {apartment:  301}}">
		<polygon id="_x33_01" class="svg-transparent" points="759.93,405.82 823.2,405.82 823.2,290.95 757.49,290.95 757.49,343.09 596.04,343.09
			596.04,426.19 759.93,426.19 	"/>
	</router-link>
	<polygon id="_x33_02" class="svg-floorplate" points="936.49,290.95 823.2,290.95 823.2,405.82 875.39,405.82 875.39,420.49 936.49,420.49
		"/>
	<polygon id="_x33_03" class="svg-floorplate" points="1072.55,438.44 1072.55,367.56 1107.58,367.56 1107.58,297.49 1072.55,290.98
		936.49,290.98 936.49,422.96 960.12,422.96 960.12,438.44 	"/>
	<polygon id="_x33_04" class="svg-floorplate" points="1072.55,110.14 1072.55,182.65 1107.58,182.65 1107.58,254.34 1072.55,261.68
		936.49,261.68 936.49,125.51 960.12,125.51 960.12,110.14 	"/>
	<polygon id="_x33_05" class="svg-floorplate" points="936.49,163.04 890.05,163.04 890.05,132.9 766.08,132.9 766.08,261.62 936.49,261.62
		"/>
	<polygon id="_x33_06" class="svg-floorplate" points="596.04,163.85 646.48,163.85 646.48,132.81 766.08,132.81 766.08,261.53 596.04,261.53
		"/>
	<polygon id="_x33_07" class="svg-floorplate" points="596.04,261.62 596.04,163.85 547.87,163.85 547.87,132.9 428.93,132.9 428.93,261.63
		"/>
	<polygon id="_x33_08" class="svg-floorplate" points="257.02,261.53 257.02,163.04 305.63,163.04 305.63,132.81 428.87,132.81 428.87,261.55
		"/>
	<polygon id="_x33_09" class="svg-floorplate" points="193.48,150 257.03,150 257.03,261.62 125.04,261.62 125.04,233.1 140.52,233.1
		140.52,208.66 125.04,208.66 125.04,112.53 193.48,112.53 	"/>
	<polygon id="_x33_10" class="svg-floorplate" points="193.48,401.76 257.02,401.77 257.02,290.96 125.04,290.96 125.04,318.66 140.52,318.66
		140.52,343.11 125.04,343.11 125.04,438.43 193.48,438.43 	"/>
	<polygon id="_x33_11" class="svg-floorplate" points="427.3,418.04 427.3,290.95 257.03,290.95 257.03,387.9 306.72,387.9 306.72,418.04 	"/>
	<polygon id="_x33_12" class="svg-floorplate" points="547.88,396.05 596.04,396.05 596.04,290.95 427.3,290.95 427.3,418.04 547.88,418.04
		"/>
</g>
<g id="STROKES">
	<line class="st2" x1="1072.55" y1="182.59" x2="1072.55" y2="261.62"/>
	<line class="st2" x1="1072.55" y1="367.53" x2="1072.55" y2="438.41"/>
	<line class="st2" x1="125.04" y1="343.09" x2="125.04" y2="438.41"/>
	<line class="st2" x1="1072.55" y1="367.53" x2="1107.58" y2="367.53"/>
	<line class="st2" x1="1072.55" y1="182.59" x2="1107.58" y2="182.59"/>
	<line class="st2" x1="960.12" y1="422.93" x2="936.49" y2="422.93"/>
	<line class="st2" x1="960.12" y1="438.41" x2="960.12" y2="422.93"/>
	<line class="st2" x1="1107.58" y1="438.41" x2="960.12" y2="438.41"/>
	<line class="st2" x1="1107.58" y1="297.47" x2="1107.58" y2="438.41"/>
	<line class="st2" x1="1072.55" y1="290.95" x2="1107.58" y2="297.47"/>
	<line class="st2" x1="1072.55" y1="261.62" x2="1072.55" y2="290.95"/>
	<line class="st2" x1="1107.58" y1="254.29" x2="1072.55" y2="261.62"/>
	<line class="st2" x1="1107.58" y1="110.08" x2="1107.58" y2="254.29"/>
	<line class="st2" x1="960.12" y1="110.08" x2="1107.58" y2="110.08"/>
	<line class="st2" x1="960.12" y1="125.56" x2="960.12" y2="110.08"/>
	<line class="st2" x1="936.49" y1="125.56" x2="960.12" y2="125.56"/>
	<line class="st2" x1="890.05" y1="163.04" x2="936.49" y2="163.04"/>
	<line class="st2" x1="890.05" y1="132.89" x2="890.05" y2="163.04"/>
	<line class="st2" x1="766.08" y1="132.89" x2="890.05" y2="132.89"/>
	<line class="st2" x1="766.08" y1="261.62" x2="766.08" y2="118.23"/>
	<line class="st2" x1="646.48" y1="132.89" x2="766.08" y2="132.89"/>
	<line class="st2" x1="646.48" y1="163.85" x2="646.48" y2="132.89"/>
	<line class="st2" x1="596.04" y1="163.85" x2="646.48" y2="163.85"/>
	<line class="st2" x1="305.63" y1="132.89" x2="428.11" y2="132.89"/>
	<line class="st2" x1="305.63" y1="163.04" x2="305.63" y2="132.89"/>
	<line class="st2" x1="257.02" y1="163.04" x2="305.63" y2="163.04"/>
	<line class="st2" x1="428.93" y1="261.62" x2="428.93" y2="118.23"/>
	<line class="st2" x1="547.87" y1="163.85" x2="596.04" y2="163.85"/>
	<line class="st2" x1="547.87" y1="132.89" x2="547.87" y2="163.85"/>
	<line class="st2" x1="547.87" y1="396.05" x2="547.87" y2="418.04"/>
	<line class="st2" x1="596.04" y1="396.05" x2="547.87" y2="396.05"/>
	<line class="st2" x1="875.39" y1="420.49" x2="936.49" y2="420.49"/>
	<line class="st2" x1="936.49" y1="290.95" x2="936.49" y2="420.49"/>
	<line class="st2" x1="140.52" y1="343.09" x2="125.04" y2="343.09"/>
	<line class="st2" x1="140.52" y1="318.65" x2="140.52" y2="343.09"/>
	<line class="st2" x1="125.04" y1="318.65" x2="140.52" y2="318.65"/>
	<line class="st2" x1="140.52" y1="261.62" x2="140.52" y2="290.95"/>
	<line class="st2" x1="427.3" y1="418.04" x2="547.87" y2="418.04"/>
	<line class="st2" x1="306.72" y1="387.9" x2="257.02" y2="387.9"/>
	<line class="st2" x1="306.72" y1="418.04" x2="306.72" y2="387.9"/>
	<line class="st2" x1="427.3" y1="418.04" x2="306.72" y2="418.04"/>
	<line class="st2" x1="257.02" y1="290.95" x2="257.02" y2="438.41"/>
	<line class="st2" x1="193.47" y1="401.75" x2="257.02" y2="401.75"/>
	<line class="st2" x1="193.47" y1="438.41" x2="193.47" y2="401.75"/>
	<line class="st2" x1="125.04" y1="438.41" x2="936.49" y2="438.41"/>
	<line class="st2" x1="125.04" y1="290.95" x2="125.04" y2="318.65"/>
	<line class="st2" x1="596.04" y1="290.95" x2="125.04" y2="290.95"/>
	<line class="st2" x1="427.3" y1="438.41" x2="427.3" y2="290.95"/>
	<line class="st2" x1="428.93" y1="132.89" x2="547.87" y2="132.89"/>
	<line class="st2" x1="257.02" y1="118.23" x2="257.02" y2="261.62"/>
	<line class="st2" x1="193.47" y1="150" x2="257.02" y2="150"/>
	<line class="st2" x1="193.47" y1="112.53" x2="193.47" y2="150"/>
	<line class="st2" x1="125.04" y1="112.53" x2="193.47" y2="112.53"/>
	<line class="st2" x1="125.04" y1="208.66" x2="125.04" y2="112.53"/>
	<line class="st2" x1="140.52" y1="208.66" x2="125.04" y2="208.66"/>
	<line class="st2" x1="140.52" y1="233.1" x2="140.52" y2="208.66"/>
	<line class="st2" x1="125.04" y1="233.1" x2="140.52" y2="233.1"/>
	<line class="st2" x1="125.04" y1="261.62" x2="125.04" y2="233.1"/>
	<line class="st2" x1="823.2" y1="438.41" x2="823.2" y2="290.95"/>
	<line class="st2" x1="936.49" y1="438.41" x2="936.49" y2="420.49"/>
	<line class="st2" x1="936.49" y1="118.23" x2="193.47" y2="118.23"/>
	<line class="st2" x1="596.04" y1="261.62" x2="596.04" y2="118.23"/>
	<line class="st2" x1="1073.32" y1="261.62" x2="125.81" y2="261.62"/>
	<line class="st2" x1="757.49" y1="290.95" x2="1072.55" y2="290.95"/>
	<line class="st2" x1="757.49" y1="343.09" x2="596.04" y2="343.09"/>
	<line class="st2" x1="757.49" y1="290.95" x2="757.49" y2="343.09"/>
	<line class="st2" x1="596.04" y1="299.91" x2="757.49" y2="299.91"/>
	<line class="st2" x1="596.04" y1="438.41" x2="596.04" y2="290.95"/>
	<line class="st2" x1="759.93" y1="426.19" x2="596.04" y2="426.19"/>
	<line class="st2" x1="759.93" y1="405.82" x2="759.93" y2="426.19"/>
	<line class="st2" x1="875.39" y1="405.82" x2="759.93" y2="405.82"/>
	<line class="st2" x1="875.39" y1="420.49" x2="875.39" y2="405.82"/>
	<line class="st2" x1="936.49" y1="118.23" x2="936.49" y2="261.62"/>
	<line class="st2" x1="936.49" y1="290.95" x2="823.2" y2="290.95"/>
	<line class="st2" x1="823.2" y1="290.95" x2="823.2" y2="405.82"/>
	<line class="st2" x1="823.2" y1="405.82" x2="875.39" y2="405.82"/>
	<line class="st2" x1="875.39" y1="405.82" x2="875.39" y2="420.49"/>
	<line class="st2" x1="875.39" y1="420.49" x2="936.49" y2="420.49"/>
	<line class="st2" x1="936.49" y1="420.49" x2="936.49" y2="290.95"/>
</g>
<g id="KEY_FRAME">
	<polyline class="st3" points="1072.55,290.95 1107.58,297.47 1107.58,438.41 960.12,438.41 960.12,422.93 936.49,422.93
		936.49,438.41 125.04,438.41 125.04,343.09 140.52,343.09 140.52,318.65 125.04,318.65 125.04,290.95 140.52,290.95 140.52,261.62
		125.04,261.62 125.04,233.1 140.52,233.1 140.52,208.66 125.04,208.66 125.04,112.53 193.47,112.53 193.47,118.23 936.49,118.23
		936.49,125.56 960.12,125.56 960.12,110.08 1107.58,110.08 1107.58,254.29 1072.55,261.62 1072.55,290.95 	"/>
</g>
</svg>

</template>

<script>
export default {

}
</script>

<style>
  .st2{fill:none;stroke:#1D1D1B;stroke-width:1.5733;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st3{fill:none;stroke:#231F20;stroke-width:6.2111;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
</style>